import(/* webpackMode: "eager" */ "/app/apps/corp/src/app/global-error.tsx");
